module.exports = __webpack_public_path__ + "media/images/countryrect/ro-252011fae16ba3c3aefa18cf7a459fbd.svg";